// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1M_lO","head":"ProcedureTableInfo_head__2jLaN"};